import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "generico",
  "use": "generico-usage",
  "viewBox": "0 0 24 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 30\" id=\"generico\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#898989\" d=\"M2 0h22v30H2z\" /><path fill=\"#FFF\" d=\"M3 1h20v28H3z\" /><path fill=\"#898989\" d=\"M0 8h22v14H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol